import { action, computed, makeObservable, observable } from 'mobx'

import { IUploadLog } from '~/client/graph'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'
import Guard from '~/client/src/shared/utils/Guard'

import { GET_UPLOAD_LOGS } from '../EventStore/eventConstants'

export default class UploadLogsStore {
  @observable public isDataReceived: boolean = false
  public constructor(private readonly eventsStore: EventsStore) {
    makeObservable(this)
    Guard.requireAll({
      eventsStore,
    })
  }

  @computed
  public get list(): IUploadLog[] {
    return Array.from(this.byId.values())
  }

  public get sortedList(): IUploadLog[] {
    return this.list.sort((a, b) => b?.createdAt - a?.createdAt)
  }

  public get byId(): Map<string, IUploadLog> {
    const { uploadLogs } = this.eventsStore.appState
    return uploadLogs
  }

  @action.bound
  public clearList() {
    this.byId.clear()
  }

  @action.bound
  public receiveList(list: IUploadLog[]) {
    this.clearList()

    list.forEach(dto => {
      this.byId.set(dto?.id, dto)
    })
    this.isDataReceived = true
  }

  public receiveOne(id: string, uploadLog: IUploadLog) {
    if (uploadLog) {
      this.byId.set(id, uploadLog)
    } else {
      this.byId.delete(id)
    }
  }

  @action.bound
  public async getUploadLogs() {
    const { id: projectId } = this.eventsStore.appState.activeProject

    this.eventsStore.dispatch(GET_UPLOAD_LOGS, projectId)
  }
}
